import { combineReducers, configureStore } from "@reduxjs/toolkit";
import reservationReducer from "features/reservation/reservationSlice";
import menuReducer from "features/menu/menuSlice";
import cartReducer from "features/cart/cartSlice";
import uiReducer from "features/ui/uiSlice";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const rootReducer = combineReducers({
  reservation: reservationReducer,
  menu: menuReducer,
  cart: cartReducer,
  ui: uiReducer,
});

const persistConfig = {
  key: "glyde-preordering",
  storage,
  whitelist: ["reservation", "menu", "cart", "ui"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  // In the future, add middleware like RTK Query here for APIs
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
